import { ApiUtility } from "./ApiUtility";

class AboutService {
  route = "/posts";
  aboutRoute = "/api/Authors/5bbc60101fd2d735b0087d36?lang=";
  useractivity = "/api/"; // Audios/useractivity/useractivity"

  get = (id: string) => ApiUtility.getResult(`${this.route}/${id}`);

  getAboutData = (lang: string) => {
    return ApiUtility.get(this.aboutRoute + lang + "&skipAll=true");
  };

  updateUserActivity(product: string, productId: string, time: string) {
    return ApiUtility.post(
      this.useractivity + product + "/" + productId + "/useractivity",
      {
        activityMedium: 1,
        time: time,
        Headers: {
          authorization: localStorage.getItem("UserId"),
          Accept: "application/json",
        },
      }
    );
  }

}
export default new AboutService();
